// Generated by scripts/qa/generate-pulse-aizawa.cjs; own normalized artistic geometry.
// Full Aizawa equation, fixed seed/RK4, near-return closure; no clinical or runtime data.
export const AIZAWA_POINTS = 1536;
export const AIZAWA_GEOMETRY = new Float32Array([
  -0.241,-0.9201,0.2203,
  -0.1604,-0.9449,0.1994,
  -0.0779,-0.9618,0.1782,
  0.0058,-0.9705,0.1569,
  0.09,-0.9711,0.1354,
  0.1737,-0.9635,0.1138,
  0.2564,-0.9479,0.0921,
  0.3371,-0.9243,0.0703,
  0.4153,-0.8933,0.0487,
  0.4901,-0.8548,0.0271,
  0.561,-0.8095,0.0057,
  0.6272,-0.7575,-0.0155,
  0.6884,-0.6995,-0.0364,
  0.7437,-0.6358,-0.057,
  0.7929,-0.5672,-0.0774,
  0.8353,-0.494,-0.0974,
  0.8707,-0.4172,-0.1171,
  0.8985,-0.3373,-0.1366,
  0.9187,-0.255,-0.1559,
  0.9308,-0.1712,-0.1749,
  0.935,-0.0865,-0.1939,
  0.9308,-0.0018,-0.2127,
  0.9187,0.0821,-0.2315,
  0.8982,0.1644,-0.2501,
  0.8699,0.2443,-0.2688,
  0.8337,0.3211,-0.2873,
  0.79,0.3938,-0.3058,
  0.7394,0.462,-0.3242,
  0.6819,0.5245,-0.3423,
  0.6184,0.5809,-0.3603,
  0.5494,0.6305,-0.378,
  0.4755,0.6727,-0.3954,
  0.3974,0.7068,-0.4124,
  0.3161,0.7323,-0.429,
  0.2324,0.7489,-0.4451,
  0.1473,0.7562,-0.4607,
  0.0618,0.7539,-0.4758,
  -0.023,0.7419,-0.4903,
  -0.1059,0.7201,-0.5042,
  -0.1857,0.6885,-0.5175,
  -0.2612,0.6477,-0.5302,
  -0.3313,0.5978,-0.5422,
  -0.3945,0.5393,-0.5535,
  -0.4498,0.4732,-0.5641,
  -0.4959,0.4003,-0.5738,
  -0.5317,0.3217,-0.5827,
  -0.5563,0.2388,-0.5907,
  -0.5687,0.1532,-0.5978,
  -0.5684,0.0666,-0.6039,
  -0.5547,-0.0189,-0.6089,
  -0.5278,-0.1013,-0.6129,
  -0.4876,-0.1782,-0.6158,
  -0.4349,-0.2471,-0.6174,
  -0.3709,-0.3057,-0.6178,
  -0.2971,-0.3513,-0.6168,
  -0.216,-0.3819,-0.6142,
  -0.1305,-0.3955,-0.6098,
  -0.0441,-0.3905,-0.6035,
  0.0388,-0.3667,-0.595,
  0.1135,-0.3242,-0.584,
  0.1752,-0.265,-0.5701,
  0.2192,-0.1923,-0.5531,
  0.2415,-0.1112,-0.5324,
  0.2398,-0.0283,-0.5075,
  0.2139,0.0488,-0.478,
  0.1666,0.1126,-0.4435,
  0.1035,0.1565,-0.4037,
  0.0325,0.1769,-0.3586,
  -0.038,0.1731,-0.3083,
  -0.1002,0.148,-0.2535,
  -0.1487,0.1067,-0.1948,
  -0.1804,0.0548,-0.133,
  -0.1945,-0.0019,-0.0689,
  -0.1914,-0.0585,-0.0032,
  -0.1726,-0.111,0.0633,
  -0.14,-0.156,0.1299,
  -0.0956,-0.1908,0.1959,
  -0.042,-0.2126,0.2605,
  0.0181,-0.2192,0.3227,
  0.0809,-0.2083,0.3815,
  0.1417,-0.1786,0.4357,
  0.1948,-0.1301,0.4841,
  0.2342,-0.0653,0.5259,
  0.2551,0.0113,0.5606,
  0.2545,0.0934,0.5882,
  0.232,0.1743,0.6093,
  0.1895,0.2483,0.6245,
  0.1301,0.3106,0.6348,
  0.058,0.3583,0.6411,
  -0.0228,0.3897,0.6441,
  -0.1083,0.4041,0.6444,
  -0.195,0.402,0.6423,
  -0.2798,0.384,0.6382,
  -0.3601,0.3517,0.6322,
  -0.4337,0.3064,0.6243,
  -0.4991,0.2501,0.6147,
  -0.5548,0.1845,0.6035,
  -0.6,0.1115,0.5908,
  -0.6343,0.0329,0.577,
  -0.6572,-0.0495,0.5621,
  -0.6686,-0.1341,0.5465,
  -0.669,-0.2194,0.5303,
  -0.6582,-0.304,0.5137,
  -0.6372,-0.3865,0.4969,
  -0.6061,-0.4658,0.4799,
  -0.5658,-0.5408,0.4628,
  -0.517,-0.6105,0.4456,
  -0.4605,-0.6742,0.4283,
  -0.3973,-0.731,0.4108,
  -0.3282,-0.7805,0.393,
  -0.2541,-0.8221,0.3749,
  -0.1761,-0.8556,0.3565,
  -0.0951,-0.8805,0.3377,
  -0.0119,-0.8966,0.3185,
  0.0723,-0.9042,0.299,
  0.1569,-0.9031,0.2791,
  0.2408,-0.8934,0.2589,
  0.3233,-0.8753,0.2386,
  0.4035,-0.8492,0.2181,
  0.4807,-0.8151,0.1976,
  0.5544,-0.7739,0.1771,
  0.6235,-0.7254,0.1568,
  0.6878,-0.6706,0.1367,
  0.7464,-0.6097,0.1168,
  0.7991,-0.5435,0.0971,
  0.8452,-0.4725,0.0777,
  0.8844,-0.3974,0.0585,
  0.9163,-0.3189,0.0394,
  0.9408,-0.2378,0.0205,
  0.9573,-0.1546,0.0017,
  0.9662,-0.0703,-0.0172,
  0.9668,0.0145,-0.0361,
  0.9598,0.0989,-0.0552,
  0.9446,0.1822,-0.0744,
  0.9218,0.2637,-0.0939,
  0.8914,0.3427,-0.1136,
  0.8536,0.4183,-0.1335,
  0.809,0.49,-0.1536,
  0.7576,0.5571,-0.1739,
  0.7002,0.619,-0.1943,
  0.6371,0.6749,-0.2148,
  0.5688,0.7246,-0.2353,
  0.4961,0.7674,-0.2557,
  0.4194,0.8029,-0.276,
  0.3397,0.8308,-0.296,
  0.2574,0.8505,-0.3158,
  0.1736,0.862,-0.3353,
  0.0889,0.865,-0.3544,
  0.0043,0.8592,-0.3732,
  -0.0793,0.8448,-0.3915,
  -0.1611,0.8219,-0.4094,
  -0.2401,0.7903,-0.4269,
  -0.3154,0.7504,-0.4439,
  -0.3859,0.7025,-0.4604,
  -0.4509,0.6472,-0.4764,
  -0.5093,0.5848,-0.4918,
  -0.5604,0.5162,-0.5067,
  -0.6033,0.442,-0.5209,
  -0.637,0.3632,-0.5345,
  -0.6611,0.2808,-0.5474,
  -0.675,0.1959,-0.5596,
  -0.6779,0.1099,-0.571,
  -0.6699,0.0241,-0.5816,
  -0.6505,-0.0599,-0.5915,
  -0.6197,-0.1406,-0.6005,
  -0.578,-0.2163,-0.6086,
  -0.5258,-0.2853,-0.6159,
  -0.4638,-0.3457,-0.6223,
  -0.3932,-0.3959,-0.6277,
  -0.3154,-0.4342,-0.6322,
  -0.2324,-0.459,-0.6355,
  -0.1462,-0.4691,-0.6375,
  -0.0596,-0.4635,-0.6383,
  0.0243,-0.4418,-0.6376,
  0.1023,-0.4039,-0.6352,
  0.1707,-0.3508,-0.6311,
  0.2258,-0.2841,-0.625,
  0.2641,-0.2068,-0.6167,
  0.2825,-0.1228,-0.6058,
  0.2788,-0.0374,-0.592,
  0.2523,0.0432,-0.5747,
  0.2044,0.1122,-0.5536,
  0.139,0.1627,-0.5279,
  0.0627,0.1894,-0.4972,
  -0.0159,0.1896,-0.461,
  -0.0871,0.1641,-0.4189,
  -0.1424,0.1178,-0.3711,
  -0.1764,0.0587,-0.3177,
  -0.1875,-0.0045,-0.2596,
  -0.1775,-0.0642,-0.1974,
  -0.1504,-0.1145,-0.1322,
  -0.1108,-0.152,-0.0648,
  -0.0633,-0.1751,0.004,
  -0.0121,-0.1832,0.0736,
  0.0393,-0.1762,0.1432,
  0.0874,-0.1546,0.2121,
  0.1289,-0.119,0.2795,
  0.1602,-0.0708,0.3444,
  0.1773,-0.0118,0.4056,
  0.1764,0.0542,0.4618,
  0.1543,0.1217,0.5114,
  0.1103,0.1834,0.5534,
  0.0471,0.2319,0.5872,
  -0.0301,0.2613,0.6132,
  -0.1142,0.2686,0.6324,
  -0.1985,0.2537,0.6458,
  -0.2772,0.2182,0.6542,
  -0.3457,0.1653,0.6585,
  -0.4011,0.0986,0.6594,
  -0.4416,0.022,0.6575,
  -0.4663,-0.0611,0.6532,
  -0.4751,-0.1472,0.6472,
  -0.4685,-0.2334,0.6398,
  -0.4474,-0.3172,0.6313,
  -0.4131,-0.3963,0.622,
  -0.3668,-0.4691,0.612,
  -0.3102,-0.534,0.6012,
  -0.2449,-0.59,0.5897,
  -0.1724,-0.6363,0.5775,
  -0.0944,-0.6722,0.5646,
  -0.0125,-0.6975,0.5509,
  0.0718,-0.712,0.5364,
  0.1573,-0.7159,0.5213,
  0.2424,-0.7093,0.5057,
  0.3261,-0.6927,0.4896,
  0.4072,-0.6664,0.4731,
  0.4847,-0.631,0.4565,
  0.5578,-0.5871,0.4399,
  0.6256,-0.5355,0.4232,
  0.6874,-0.4768,0.4065,
  0.7426,-0.4118,0.39,
  0.7908,-0.3415,0.3735,
  0.8314,-0.2665,0.3571,
  0.8641,-0.1877,0.3406,
  0.8888,-0.1062,0.3239,
  0.9052,-0.0226,0.307,
  0.9133,0.0621,0.2898,
  0.9132,0.1472,0.272,
  0.9047,0.2316,0.2537,
  0.8885,0.3148,0.2347,
  0.8642,0.3958,0.215,
  0.8327,0.4742,0.1946,
  0.7938,0.5489,0.1734,
  0.7483,0.6196,0.1516,
  0.6965,0.6856,0.1291,
  0.6389,0.7464,0.1061,
  0.5762,0.8016,0.0826,
  0.5085,0.8506,0.0588,
  0.4367,0.8931,0.0346,
  0.3615,0.9291,0.0103,
  0.2832,0.9577,-0.0142,
  0.2027,0.9791,-0.0387,
  0.1206,0.9932,-0.0631,
  0.0374,0.9994,-0.0875,
  -0.046,0.9981,-0.1118,
  -0.1289,0.9893,-0.1359,
  -0.2107,0.9726,-0.1599,
  -0.2907,0.9486,-0.1837,
  -0.3682,0.9173,-0.2074,
  -0.4424,0.8787,-0.2308,
  -0.5127,0.8334,-0.2542,
  -0.5785,0.7817,-0.2773,
  -0.6392,0.7239,-0.3001,
  -0.6942,0.6606,-0.3228,
  -0.7428,0.5922,-0.3451,
  -0.7847,0.5193,-0.3671,
  -0.8192,0.4426,-0.3888,
  -0.8461,0.3628,-0.41,
  -0.865,0.2806,-0.4307,
  -0.8753,0.1968,-0.4509,
  -0.8771,0.1122,-0.4706,
  -0.8702,0.0278,-0.4897,
  -0.8544,-0.0556,-0.5081,
  -0.8297,-0.1369,-0.526,
  -0.7963,-0.2152,-0.5432,
  -0.7544,-0.2894,-0.5597,
  -0.7044,-0.3586,-0.5757,
  -0.6467,-0.4217,-0.591,
  -0.5819,-0.4775,-0.6057,
  -0.5107,-0.5252,-0.6197,
  -0.4341,-0.5639,-0.6331,
  -0.3532,-0.5926,-0.6458,
  -0.2691,-0.6105,-0.6579,
  -0.1832,-0.617,-0.6691,
  -0.0972,-0.6115,-0.6796,
  -0.0128,-0.5938,-0.6892,
  0.0682,-0.5637,-0.6979,
  0.1435,-0.5214,-0.7057,
  0.2113,-0.4676,-0.7126,
  0.2691,-0.4031,-0.7184,
  0.3146,-0.3294,-0.7231,
  0.3458,-0.2486,-0.7267,
  0.3608,-0.1632,-0.7291,
  0.3578,-0.0765,-0.73,
  0.3361,0.0074,-0.7293,
  0.2956,0.084,-0.7268,
  0.2374,0.148,-0.7221,
  0.1644,0.194,-0.7149,
  0.0816,0.2171,-0.7049,
  -0.0038,0.2132,-0.6914,
  -0.082,0.181,-0.6736,
  -0.1419,0.1233,-0.6506,
  -0.173,0.0484,-0.6212,
  -0.1691,-0.0293,-0.584,
  -0.1327,-0.0926,-0.5382,
  -0.0761,-0.1281,-0.4835,
  -0.0168,-0.1323,-0.4208,
  0.0315,-0.112,-0.3518,
  0.0621,-0.0776,-0.2784,
  0.0748,-0.0387,-0.2019,
  0.0723,-0.0015,-0.1236,
  0.0581,0.0301,-0.044,
  0.0352,0.054,0.0363,
  0.0063,0.0692,0.1168,
  -0.0264,0.0746,0.197,
  -0.0606,0.0693,0.2767,
  -0.0938,0.0521,0.355,
  -0.1224,0.0216,0.431,
  -0.1408,-0.0231,0.503,
  -0.1408,-0.08,0.5682,
  -0.1138,-0.1412,0.6228,
  -0.0572,-0.1914,0.6644,
  0.0204,-0.2158,0.6929,
  0.1045,-0.2085,0.7111,
  0.1818,-0.1714,0.7219,
  0.2436,-0.111,0.7277,
  0.285,-0.035,0.7299,
  0.3044,0.0494,0.7294,
  0.3022,0.136,0.7266,
  0.2801,0.2197,0.722,
  0.2404,0.2966,0.7156,
  0.186,0.3636,0.7078,
  0.1198,0.419,0.6989,
  0.0448,0.4614,0.6889,
  -0.0364,0.4901,0.678,
  -0.1211,0.5051,0.6664,
  -0.207,0.5064,0.654,
  -0.292,0.4948,0.6407,
  -0.3742,0.4708,0.6266,
  -0.4521,0.4357,0.6115,
  -0.5243,0.3902,0.5953,
  -0.5897,0.3357,0.578,
  -0.6473,0.2735,0.5597,
  -0.6966,0.2046,0.5405,
  -0.7369,0.1304,0.5203,
  -0.768,0.0521,0.4994,
  -0.7897,-0.0292,0.4779,
  -0.8018,-0.1124,0.4561,
  -0.8045,-0.1963,0.4339,
  -0.7979,-0.28,0.4117,
  -0.7821,-0.3624,0.3894,
  -0.7576,-0.4428,0.3673,
  -0.7246,-0.52,0.3453,
  -0.6836,-0.5934,0.3235,
  -0.6353,-0.6623,0.3019,
  -0.5802,-0.7259,0.2804,
  -0.5188,-0.7835,0.2591,
  -0.4521,-0.8348,0.2378,
  -0.3805,-0.879,0.2165,
  -0.3049,-0.9161,0.1951,
  -0.226,-0.9456,0.1736,
  -0.1447,-0.9671,0.152,
  -0.0618,-0.9808,0.1303,
  0.0221,-0.9863,0.1084,
  0.1061,-0.9839,0.0864,
  0.1894,-0.9733,0.0644,
  0.2714,-0.9549,0.0423,
  0.3512,-0.9288,0.0202,
  0.4282,-0.8951,-0.0017,
  0.5018,-0.8545,-0.0235,
  0.5711,-0.8068,-0.0451,
  0.6358,-0.7529,-0.0664,
  0.695,-0.6929,-0.0874,
  0.7484,-0.6276,-0.1081,
  0.7953,-0.5574,-0.1285,
  0.8354,-0.4831,-0.1486,
  0.8682,-0.4051,-0.1684,
  0.8936,-0.3244,-0.1879,
  0.9109,-0.2415,-0.2072,
  0.9204,-0.1573,-0.2263,
  0.9214,-0.0725,-0.2452,
  0.9144,0.012,-0.2639,
  0.8989,0.0954,-0.2825,
  0.8753,0.1769,-0.301,
  0.8437,0.2557,-0.3193,
  0.8042,0.3309,-0.3375,
  0.7574,0.4018,-0.3554,
  0.7035,0.4675,-0.3732,
  0.643,0.5273,-0.3907,
  0.5764,0.5804,-0.4079,
  0.5046,0.6262,-0.4247,
  0.4282,0.6641,-0.4411,
  0.348,0.6933,-0.4571,
  0.265,0.7136,-0.4725,
  0.1801,0.7243,-0.4874,
  0.0945,0.7253,-0.5017,
  0.0092,0.7162,-0.5154,
  -0.0744,0.697,-0.5285,
  -0.1552,0.6677,-0.5409,
  -0.2319,0.6286,-0.5527,
  -0.3029,0.5799,-0.5637,
  -0.3671,0.5224,-0.5739,
  -0.4231,0.4567,-0.5834,
  -0.4696,0.3839,-0.592,
  -0.5053,0.3051,-0.5996,
  -0.5292,0.2219,-0.6063,
  -0.5402,0.136,-0.612,
  -0.5378,0.0494,-0.6166,
  -0.5213,-0.0357,-0.6201,
  -0.4908,-0.1169,-0.6224,
  -0.4466,-0.1916,-0.6235,
  -0.3897,-0.257,-0.6232,
  -0.3212,-0.3103,-0.6214,
  -0.2437,-0.349,-0.618,
  -0.1599,-0.3707,-0.6127,
  -0.0736,-0.3735,-0.6054,
  0.0109,-0.3564,-0.5957,
  0.0883,-0.3195,-0.5832,
  0.1534,-0.2645,-0.5678,
  0.2008,-0.1946,-0.5488,
  0.2263,-0.1151,-0.5259,
  0.227,-0.0329,-0.4985,
  0.2029,0.0436,-0.4661,
  0.157,0.1065,-0.4284,
  0.0954,0.1493,-0.3852,
  0.0263,0.1685,-0.3367,
  -0.0417,0.164,-0.2832,
  -0.1012,0.139,-0.2254,
  -0.1472,0.0985,-0.164,
  -0.1771,0.0482,-0.1,
  -0.19,-0.0067,-0.0342,
  -0.1865,-0.0617,0.0329,
  -0.1677,-0.1129,0.1003,
  -0.1351,-0.1571,0.1675,
  -0.0906,-0.1913,0.2337,
  -0.0364,-0.2127,0.2979,
  0.0247,-0.2184,0.3592,
  0.0886,-0.206,0.4164,
  0.1503,-0.1739,0.4682,
  0.2033,-0.1225,0.5135,
  0.2414,-0.0547,0.5517,
  0.26,0.024,0.5826,
  0.2566,0.1072,0.6065,
  0.2315,0.1882,0.6242,
  0.1868,0.2614,0.6365,
  0.1259,0.3226,0.6442,
  0.0528,0.3691,0.6484,
  -0.0285,0.3994,0.6496,
  -0.1141,0.4131,0.6483,
  -0.2007,0.4105,0.6449,
  -0.2855,0.3925,0.6397,
  -0.3658,0.3603,0.6326,
  -0.4395,0.3154,0.6238,
  -0.5052,0.2597,0.6134,
  -0.5616,0.1948,0.6015,
  -0.6077,0.1224,0.5882,
  -0.643,0.0444,0.5737,
  -0.6672,-0.0375,0.5582,
  -0.6803,-0.1218,0.542,
  -0.6822,-0.207,0.5253,
  -0.6735,-0.2916,0.5082,
  -0.6542,-0.3745,0.4908,
  -0.6251,-0.4544,0.4733,
  -0.5868,-0.5303,0.4557,
  -0.5399,-0.6013,0.4381,
  -0.4853,-0.6664,0.4203,
  -0.4238,-0.725,0.4024,
  -0.3562,-0.7764,0.3843,
  -0.2834,-0.8202,0.366,
  -0.2065,-0.8559,0.3473,
  -0.1264,-0.8834,0.3283,
  -0.0438,-0.9023,0.309,
  0.0401,-0.9125,0.2892,
  0.1246,-0.9142,0.2692,
  0.2088,-0.9073,0.2488,
  0.2917,-0.892,0.2283,
  0.3728,-0.8687,0.2076,
  0.4511,-0.8374,0.1869,
  0.5261,-0.7986,0.1663,
  0.5968,-0.7527,0.1457,
  0.663,-0.7002,0.1253,
  0.7237,-0.6415,0.1052,
  0.7786,-0.5773,0.0852,
  0.8272,-0.508,0.0656,
  0.8691,-0.4344,0.0461,
  0.9037,-0.3571,0.0269,
  0.9311,-0.2769,0.0078,
  0.9505,-0.1944,-0.0112,
  0.9624,-0.1105,-0.0301,
  0.9661,-0.0258,-0.049,
  0.962,0.0588,-0.0681,
  0.9497,0.1426,-0.0873,
  0.9298,0.2249,-0.1066,
  0.9021,0.3049,-0.1261,
  0.8671,0.3818,-0.1459,
  0.8248,0.4551,-0.1658,
  0.7758,0.5239,-0.1858,
  0.7204,0.5877,-0.206,
  0.6592,0.6458,-0.2262,
  0.5925,0.6977,-0.2464,
  0.5212,0.743,-0.2666,
  0.4456,0.7809,-0.2865,
  0.3667,0.8113,-0.3063,
  0.2851,0.8335,-0.3258,
  0.2015,0.8475,-0.345,
  0.1169,0.8531,-0.3638,
  0.0321,0.8498,-0.3823,
  -0.052,0.8376,-0.4003,
  -0.1344,0.8168,-0.4178,
  -0.2143,0.7873,-0.435,
  -0.2906,0.7493,-0.4516,
  -0.3624,0.7032,-0.4677,
  -0.4286,0.6493,-0.4833,
  -0.4885,0.5882,-0.4983,
  -0.5409,0.5205,-0.5128,
  -0.5852,0.4471,-0.5266,
  -0.6205,0.3688,-0.5397,
  -0.6458,0.2867,-0.5521,
  -0.6609,0.202,-0.5638,
  -0.6649,0.116,-0.5747,
  -0.6578,0.0301,-0.5848,
  -0.639,-0.0542,-0.5941,
  -0.6088,-0.1351,-0.6025,
  -0.5673,-0.211,-0.6101,
  -0.5151,-0.28,-0.6168,
  -0.4529,-0.3403,-0.6225,
  -0.382,-0.3902,-0.6273,
  -0.3038,-0.4277,-0.6309,
  -0.2204,-0.4515,-0.6334,
  -0.1341,-0.4602,-0.6346,
  -0.0477,-0.4527,-0.6345,
  0.0357,-0.4288,-0.6327,
  0.1124,-0.3886,-0.6293,
  0.1787,-0.333,-0.6239,
  0.2309,-0.2641,-0.6164,
  0.2652,-0.1852,-0.6065,
  0.2787,-0.1005,-0.5939,
  0.2696,-0.0159,-0.578,
  0.2377,0.0622,-0.5585,
  0.185,0.1267,-0.5347,
  0.1163,0.171,-0.5062,
  0.0391,0.1904,-0.4724,
  -0.0376,0.1834,-0.4329,
  -0.1044,0.1521,-0.3877,
  -0.1539,0.1024,-0.3369,
  -0.1819,0.0424,-0.2811,
  -0.1879,-0.0197,-0.221,
  -0.1743,-0.0771,-0.1574,
  -0.1447,-0.1248,-0.0913,
  -0.1037,-0.16,-0.0235,
  -0.0552,-0.181,0.0454,
  -0.0032,-0.1872,0.1145,
  0.049,-0.1783,0.1833,
  0.0979,-0.1545,0.2509,
  0.1399,-0.1162,0.3164,
  0.1711,-0.0646,0.3788,
  0.1871,-0.0022,0.4367,
  0.1839,0.067,0.4887,
  0.1588,0.1367,0.5336,
  0.1119,0.1994,0.5706,
  0.0464,0.2479,0.5998,
  -0.0321,0.2772,0.6217,
  -0.117,0.285,0.6375,
  -0.2019,0.2713,0.6481,
  -0.2816,0.2378,0.6543,
  -0.352,0.1873,0.6569,
  -0.4104,0.1232,0.6563,
  -0.4548,0.0487,0.6531,
  -0.4843,-0.0327,0.6477,
  -0.4987,-0.118,0.6407,
  -0.4981,-0.2043,0.6323,
  -0.4834,-0.2893,0.623,
  -0.4554,-0.3709,0.6128,
  -0.4155,-0.4472,0.602,
  -0.3648,-0.5167,0.5906,
  -0.3048,-0.5783,0.5786,
  -0.237,-0.631,0.5659,
  -0.1629,-0.6742,0.5526,
  -0.0838,-0.7073,0.5386,
  -0.0014,-0.7302,0.5239,
  0.0832,-0.7427,0.5085,
  0.1685,-0.7449,0.4925,
  0.2534,-0.7372,0.4761,
  0.3368,-0.7197,0.4592,
  0.4175,-0.6928,0.442,
  0.4948,-0.6572,0.4247,
  0.5677,-0.6134,0.4074,
  0.6355,-0.562,0.39,
  0.6976,-0.5037,0.3728,
  0.7532,-0.4392,0.3557,
  0.8019,-0.3693,0.3387,
  0.8432,-0.2949,0.3217,
  0.8771,-0.2167,0.3047,
  0.9027,-0.1355,0.2877,
  0.9205,-0.0523,0.2704,
  0.93,0.0323,0.2529,
  0.9314,0.1172,0.2349,
  0.9246,0.2018,0.2164,
  0.9099,0.2853,0.1974,
  0.8874,0.3668,0.1777,
  0.8575,0.4458,0.1573,
  0.8203,0.5214,0.1363,
  0.7765,0.5931,0.1146,
  0.7261,0.6603,0.0923,
  0.6699,0.7225,0.0695,
  0.6084,0.7792,0.0463,
  0.5418,0.8297,0.0227,
  0.471,0.874,-0.0012,
  0.3965,0.9117,-0.0252,
  0.3188,0.9421,-0.0494,
  0.2387,0.9654,-0.0735,
  0.1568,0.9813,-0.0976,
  0.0738,0.9894,-0.1217,
  -0.0097,0.99,-0.1455,
  -0.093,0.9828,-0.1692,
  -0.1752,0.9678,-0.1928,
  -0.2558,0.9454,-0.2161,
  -0.334,0.9153,-0.2392,
  -0.409,0.8781,-0.2621,
  -0.4803,0.8339,-0.2848,
  -0.547,0.7831,-0.3072,
  -0.6087,0.7261,-0.3294,
  -0.6646,0.6633,-0.3512,
  -0.7142,0.5953,-0.3728,
  -0.7569,0.5227,-0.3939,
  -0.7921,0.4461,-0.4147,
  -0.8197,0.3663,-0.435,
  -0.8389,0.284,-0.4548,
  -0.8495,0.2,-0.474,
  -0.8514,0.1152,-0.4927,
  -0.8443,0.0305,-0.5108,
  -0.8281,-0.053,-0.5282,
  -0.8027,-0.1344,-0.545,
  -0.7684,-0.2125,-0.5611,
  -0.7253,-0.2863,-0.5766,
  -0.6739,-0.3546,-0.5914,
  -0.6146,-0.4165,-0.6056,
  -0.5483,-0.4709,-0.6192,
  -0.4755,-0.5164,-0.6321,
  -0.3975,-0.5525,-0.6443,
  -0.3152,-0.5778,-0.6558,
  -0.2302,-0.5918,-0.6665,
  -0.144,-0.5937,-0.6764,
  -0.0583,-0.583,-0.6855,
  0.0248,-0.5596,-0.6936,
  0.1034,-0.5233,-0.7008,
  0.175,-0.4747,-0.707,
  0.2373,-0.4146,-0.7121,
  0.2879,-0.3442,-0.7161,
  0.3245,-0.2656,-0.7189,
  0.3447,-0.1813,-0.7203,
  0.3469,-0.0946,-0.7203,
  0.3297,-0.0096,-0.7185,
  0.293,0.0688,-0.7148,
  0.2377,0.1352,-0.7088,
  0.1667,0.1839,-0.7002,
  0.0849,0.2096,-0.6884,
  -0.0002,0.2081,-0.6728,
  -0.0786,0.1778,-0.6527,
  -0.1389,0.1217,-0.6269,
  -0.1708,0.0484,-0.5944,
  -0.1684,-0.0278,-0.5539,
  -0.1346,-0.0903,-0.505,
  -0.0814,-0.1272,-0.4478,
  -0.0241,-0.1352,-0.3835,
  0.0247,-0.1197,-0.3137,
  0.0588,-0.0893,-0.24,
  0.0769,-0.0523,-0.1636,
  0.0802,-0.0144,-0.0856,
  0.071,0.0203,-0.0066,
  0.0518,0.0494,0.073,
  0.0244,0.0708,0.1525,
  -0.0091,0.0831,0.2317,
  -0.0468,0.0844,0.3098,
  -0.0864,0.0725,0.3862,
  -0.1239,0.0448,0.4593,
  -0.1529,-0.0006,0.5272,
  -0.164,-0.0624,0.5867,
  -0.1477,-0.1322,0.6347,
  -0.1007,-0.1955,0.67,
  -0.0296,-0.2381,0.6939,
  0.0542,-0.2529,0.709,
  0.1392,-0.2393,0.7178,
  0.2166,-0.2006,0.7221,
  0.2803,-0.142,0.7233,
  0.3271,-0.0691,0.7223,
  0.3553,0.0128,0.7194,
  0.3648,0.0989,0.7148,
  0.3563,0.185,0.7086,
  0.3311,0.2677,0.701,
  0.2912,0.3442,0.6921,
  0.2386,0.4124,0.6819,
  0.1753,0.4708,0.6707,
  0.1037,0.5182,0.6585,
  0.0256,0.554,0.6457,
  -0.0567,0.5779,0.6321,
  -0.1415,0.5897,0.6179,
  -0.2271,0.5899,0.603,
  -0.3117,0.5785,0.5874,
  -0.394,0.5563,0.571,
  -0.4727,0.5239,0.5537,
  -0.5467,0.4823,0.5355,
  -0.615,0.4322,0.5163,
  -0.6767,0.3745,0.4961,
  -0.7312,0.3103,0.4749,
  -0.7779,0.2405,0.4529,
  -0.8165,0.1661,0.4301,
  -0.8466,0.0881,0.4067,
  -0.8681,0.0074,0.3828,
  -0.881,-0.075,0.3586,
  -0.8852,-0.1582,0.3342,
  -0.8805,-0.2414,0.3098,
  -0.8675,-0.3238,0.2854,
  -0.8462,-0.4044,0.2612,
  -0.8167,-0.4825,0.2373,
  -0.7797,-0.5575,0.2136,
  -0.7352,-0.6283,0.1903,
  -0.6841,-0.6946,0.1672,
  -0.6266,-0.7556,0.1444,
  -0.5635,-0.8109,0.1218,
  -0.4952,-0.8596,0.0995,
  -0.4227,-0.9018,0.0772,
  -0.3462,-0.9367,0.0551,
  -0.2669,-0.9643,0.033,
  -0.1852,-0.984,0.011,
  -0.1021,-0.996,-0.0111,
  -0.0182,-0.9999,-0.0331,
  0.0658,-0.996,-0.0551,
  0.1489,-0.984,-0.077,
  0.2306,-0.9641,-0.0988,
  0.3101,-0.9366,-0.1204,
  0.3866,-0.9016,-0.1419,
  0.4595,-0.8594,-0.1631,
  0.528,-0.8103,-0.1841,
  0.5916,-0.7549,-0.2047,
  0.6495,-0.6934,-0.2249,
  0.7013,-0.6265,-0.2448,
  0.7463,-0.5549,-0.2644,
  0.784,-0.479,-0.2835,
  0.8143,-0.3998,-0.3023,
  0.8362,-0.3178,-0.3207,
  0.8499,-0.234,-0.3388,
  0.8551,-0.1492,-0.3566,
  0.8514,-0.0642,-0.3741,
  0.8389,0.02,-0.3912,
  0.8177,0.1026,-0.408,
  0.7878,0.1824,-0.4245,
  0.7494,0.2586,-0.4406,
  0.7029,0.3302,-0.4563,
  0.6487,0.3963,-0.4716,
  0.5872,0.4559,-0.4863,
  0.5193,0.508,-0.5006,
  0.4457,0.552,-0.5142,
  0.3672,0.5869,-0.5273,
  0.285,0.6119,-0.5396,
  0.2002,0.6266,-0.5513,
  0.1142,0.6303,-0.5623,
  0.0283,0.6229,-0.5725,
  -0.0559,0.6039,-0.582,
  -0.1367,0.5734,-0.5906,
  -0.2125,0.5318,-0.5983,
  -0.2815,0.4796,-0.6051,
  -0.3418,0.4175,-0.6109,
  -0.3918,0.3466,-0.6156,
  -0.4297,0.2686,-0.6192,
  -0.4539,0.1854,-0.6215,
  -0.4633,0.0991,-0.6226,
  -0.4568,0.0126,-0.6222,
  -0.434,-0.0711,-0.6202,
  -0.3951,-0.1485,-0.6167,
  -0.341,-0.216,-0.6112,
  -0.2736,-0.27,-0.6037,
  -0.1957,-0.3069,-0.5939,
  -0.1117,-0.3238,-0.5814,
  -0.0266,-0.3188,-0.5658,
  0.0533,-0.2913,-0.5467,
  0.1214,-0.243,-0.5237,
  0.1713,-0.1778,-0.4962,
  0.198,-0.1022,-0.4637,
  0.1992,-0.0243,-0.4259,
  0.1759,0.047,-0.3827,
  0.1324,0.1039,-0.3341,
  0.0756,0.1415,-0.2807,
  0.013,0.1577,-0.2229,
  -0.0482,0.1535,-0.1617,
  -0.1027,0.1317,-0.0979,
  -0.1465,0.0959,-0.0321,
  -0.1774,0.0501,0.0347,
  -0.1938,-0.0022,0.102,
  -0.1951,-0.0574,0.169,
  -0.1807,-0.112,0.2349,
  -0.1507,-0.1623,0.2988,
  -0.1056,-0.2044,0.3598,
  -0.0472,-0.2339,0.4167,
  0.0215,-0.2463,0.4681,
  0.0951,-0.2383,0.513,
  0.167,-0.2082,0.5507,
  0.2303,-0.1574,0.5812,
  0.2788,-0.0898,0.605,
  0.309,-0.0106,0.623,
  0.3191,0.0745,0.6358,
  0.3093,0.1602,0.6442,
  0.2808,0.242,0.6488,
  0.236,0.3162,0.6503,
  0.1774,0.3802,0.649,
  0.1079,0.4321,0.6456,
  0.0304,0.4707,0.6404,
  -0.0524,0.4956,0.6336,
  -0.1382,0.5066,0.6255,
  -0.2244,0.504,0.6162,
  -0.3092,0.4885,0.6056,
  -0.3906,0.4608,0.5939,
  -0.4671,0.422,0.5808,
  -0.5375,0.3732,0.5665,
  -0.6007,0.3157,0.5509,
  -0.6556,0.2506,0.5342,
  -0.7019,0.1794,0.5163,
  -0.739,0.1031,0.4975,
  -0.7665,0.0231,0.478,
  -0.7843,-0.0594,0.4578,
  -0.7925,-0.1434,0.4372,
  -0.7911,-0.2277,0.4163,
  -0.7802,-0.3112,0.3953,
  -0.7603,-0.3931,0.3743,
  -0.7316,-0.4723,0.3533,
  -0.6945,-0.5481,0.3325,
  -0.6496,-0.6194,0.3118,
  -0.5975,-0.6858,0.2913,
  -0.5389,-0.7465,0.2708,
  -0.4742,-0.8008,0.2504,
  -0.4045,-0.8483,0.23,
  -0.3304,-0.8888,0.2095,
  -0.2525,-0.9214,0.1889,
  -0.172,-0.9463,0.1682,
  -0.0894,-0.963,0.1473,
  -0.0056,-0.9717,0.1262,
  0.0787,-0.9722,0.105,
  0.1625,-0.9645,0.0836,
  0.2452,-0.9488,0.0622,
  0.326,-0.9251,0.0408,
  0.4041,-0.8939,0.0195,
  0.479,-0.8552,-0.0017,
  0.5498,-0.8096,-0.0228,
  0.616,-0.7574,-0.0436,
  0.677,-0.6991,-0.0641,
  0.7322,-0.6351,-0.0843,
  0.781,-0.5661,-0.1043,
  0.8231,-0.4927,-0.1239,
  0.8579,-0.4155,-0.1432,
  0.8852,-0.3353,-0.1623,
  0.9047,-0.2528,-0.1811,
  0.916,-0.1687,-0.1997,
  0.9193,-0.0839,-0.2181,
  0.914,0.0008,-0.2364,
  0.9007,0.0847,-0.2546,
  0.8789,0.1668,-0.2727,
  0.8491,0.2463,-0.2907,
  0.8115,0.3226,-0.3086,
  0.7662,0.3945,-0.3263,
  0.7139,0.4616,-0.3439,
  0.6549,0.5229,-0.3612,
  0.5898,0.5778,-0.3783,
  0.5191,0.6254,-0.3951,
  0.4437,0.6652,-0.4115,
  0.3644,0.6967,-0.4275,
  0.282,0.7193,-0.443,
  0.1975,0.7326,-0.458,
  0.112,0.7363,-0.4725,
  0.0265,0.7301,-0.4864,
  -0.0578,0.7138,-0.4997,
  -0.1395,0.6875,-0.5124,
  -0.2176,0.6515,-0.5244,
  -0.2906,0.6059,-0.5357,
  -0.3574,0.5514,-0.5464,
  -0.4164,0.4885,-0.5562,
  -0.4666,0.4183,-0.5653,
  -0.5067,0.3417,-0.5734,
  -0.5357,0.2602,-0.5807,
  -0.5524,0.1753,-0.587,
  -0.5563,0.0887,-0.5923,
  -0.5467,0.0026,-0.5966,
  -0.5235,-0.081,-0.5997,
  -0.4866,-0.1595,-0.6016,
  -0.4367,-0.2305,-0.6023,
  -0.3749,-0.2915,-0.6016,
  -0.3029,-0.3397,-0.5994,
  -0.2229,-0.373,-0.5956,
  -0.1379,-0.3892,-0.59,
  -0.0515,-0.3869,-0.5822,
  0.0318,-0.3655,-0.5722,
  0.1075,-0.3252,-0.5595,
  0.1707,-0.268,-0.5439,
  0.2165,-0.1969,-0.525,
  0.2411,-0.117,-0.5024,
  0.2423,-0.0347,-0.4755,
  0.2197,0.0428,-0.4441,
  0.176,0.1082,-0.4079,
  0.1163,0.1553,-0.3666,
  0.0475,0.1806,-0.3205,
  -0.0228,0.183,-0.2698,
  -0.0873,0.1644,-0.2151,
  -0.1408,0.1287,-0.1569,
  -0.1798,0.0807,-0.0962,
  -0.2026,0.0252,-0.0335,
  -0.2086,-0.0333,0.0303,
  -0.1984,-0.0906,0.0946,
  -0.1728,-0.1433,0.1586,
  -0.1334,-0.188,0.2217,
  -0.0818,-0.2215,0.2829,
  -0.0207,-0.2408,0.3413,
  0.0467,-0.243,0.3958,
  0.1157,-0.2259,0.4454,
  0.1808,-0.1891,0.4891,
  0.236,-0.1337,0.5266,
  0.2761,-0.0634,0.5575,
  0.2975,0.0169,0.5822,
  0.2985,0.1014,0.6011,
  0.2796,0.1849,0.6149,
  0.2422,0.2625,0.6241,
  0.189,0.3308,0.6295,
  0.1229,0.387,0.6318,
  0.0473,0.4294,0.6314,
  -0.0348,0.4573,0.6289,
  -0.1205,0.4703,0.6245,
  -0.2071,0.4688,0.6185,
  -0.2921,0.4534,0.6109,
  -0.3737,0.4251,0.6018,
  -0.4499,0.3849,0.5912,
  -0.5194,0.3343,0.5791,
  -0.5809,0.2745,0.5657,
  -0.6336,0.2071,0.5508,
  -0.6769,0.1336,0.5349,
  -0.7102,0.0552,0.5179,
  -0.7334,-0.0265,0.5,
  -0.7464,-0.1104,0.4816,
  -0.7491,-0.1951,0.4627,
  -0.7418,-0.2794,0.4435,
  -0.7249,-0.3624,0.4242,
  -0.6987,-0.4429,0.4049,
  -0.6636,-0.5199,0.3855,
  -0.6203,-0.5927,0.3662,
  -0.5694,-0.6603,0.347,
  -0.5115,-0.7222,0.3278,
  -0.4473,-0.7774,0.3085,
  -0.3778,-0.8258,0.2891,
  -0.3038,-0.8667,0.2696,
  -0.226,-0.8999,0.2499,
  -0.1452,-0.9249,0.2299,
  -0.0625,-0.9418,0.2097,
  0.0215,-0.9502,0.1893,
  0.1059,-0.9504,0.1686,
  0.1898,-0.9423,0.1478,
  0.2725,-0.926,0.1268,
  0.3532,-0.9018,0.1057,
  0.4311,-0.8698,0.0847,
  0.5057,-0.8306,0.0638,
  0.5762,-0.7842,0.043,
  0.642,-0.7313,0.0225,
  0.7023,-0.6723,0.0022,
  0.757,-0.6078,-0.0179,
  0.8051,-0.5383,-0.0376,
  0.8466,-0.4645,-0.0571,
  0.8807,-0.387,-0.0763,
  0.9074,-0.3066,-0.0953,
  0.9263,-0.2239,-0.1141,
  0.9373,-0.1398,-0.1328,
  0.94,-0.055,-0.1514,
  0.9347,0.0297,-0.1699,
  0.9211,0.1134,-0.1884,
  0.8997,0.1955,-0.207,
  0.8701,0.275,-0.2255,
  0.833,0.3514,-0.2441,
  0.7885,0.4236,-0.2627,
  0.7371,0.491,-0.2812,
  0.6792,0.5531,-0.2996,
  0.6152,0.6089,-0.3179,
  0.5458,0.658,-0.336,
  0.4718,0.6997,-0.3538,
  0.3938,0.7336,-0.3714,
  0.3125,0.759,-0.3885,
  0.229,0.7756,-0.4053,
  0.144,0.7832,-0.4216,
  0.0587,0.7815,-0.4374,
  -0.0261,0.7703,-0.4527,
  -0.1091,0.7497,-0.4675,
  -0.1894,0.7197,-0.4818,
  -0.2657,0.6805,-0.4954,
  -0.3368,0.6325,-0.5084,
  -0.4017,0.5761,-0.5208,
  -0.4593,0.5123,-0.5325,
  -0.5083,0.4414,-0.5435,
  -0.548,0.3649,-0.5538,
  -0.5771,0.2836,-0.5632,
  -0.595,0.1991,-0.5717,
  -0.6009,0.1128,-0.5794,
  -0.5944,0.0265,-0.5862,
  -0.5753,-0.0579,-0.5919,
  -0.5433,-0.1385,-0.5967,
  -0.4991,-0.2131,-0.6004,
  -0.4433,-0.2795,-0.603,
  -0.3769,-0.3354,-0.6044,
  -0.3018,-0.3788,-0.6045,
  -0.22,-0.4077,-0.6032,
  -0.1343,-0.4203,-0.6002,
  -0.0478,-0.4156,-0.5955,
  0.0356,-0.3929,-0.5889,
  0.1118,-0.3525,-0.58,
  0.1765,-0.2959,-0.5686,
  0.2253,-0.2257,-0.5545,
  0.2546,-0.146,-0.5373,
  0.2615,-0.0622,-0.5164,
  0.2452,0.0191,-0.4916,
  0.2067,0.0909,-0.4623,
  0.1498,0.1466,-0.4282,
  0.0806,0.1811,-0.3892,
  0.0069,0.1918,-0.3451,
  -0.0635,0.1793,-0.2963,
  -0.1238,0.1469,-0.243,
  -0.169,0.0998,-0.1861,
  -0.1967,0.0436,-0.1261,
  -0.2063,-0.0161,-0.0639,
  -0.1986,-0.0744,-0.0001,
  -0.1753,-0.1275,0.0644,
  -0.1384,-0.1721,0.129,
  -0.0902,-0.2054,0.1931,
  -0.0334,-0.225,0.2556,
  0.0289,-0.2288,0.3158,
  0.0929,-0.215,0.3727,
  0.1539,-0.1826,0.4251,
  0.2066,-0.1323,0.472,
  0.2454,-0.0664,0.5128,
  0.2661,0.0105,0.5469,
  0.2661,0.0926,0.5744,
  0.2449,0.1739,0.5956,
  0.2041,0.2488,0.6113,
  0.1468,0.3129,0.6221,
  0.0764,0.3631,0.6289,
  -0.003,0.3978,0.6324,
  -0.0878,0.416,0.6331,
  -0.1745,0.4181,0.6316,
  -0.2601,0.4045,0.6279,
  -0.3421,0.3764,0.6222,
  -0.4181,0.3353,0.6148,
  -0.4866,0.2828,0.6056,
  -0.5462,0.2206,0.5947,
  -0.5958,0.1505,0.5824,
  -0.6348,0.0741,0.5687,
  -0.6628,-0.0067,0.554,
  -0.6797,-0.0905,0.5384,
  -0.6855,-0.1755,0.5221,
  -0.6804,-0.2606,0.5054,
  -0.6647,-0.3443,0.4884,
  -0.639,-0.4254,0.4712,
  -0.6039,-0.5029,0.4539,
  -0.56,-0.5758,0.4365,
  -0.508,-0.6431,0.419,
  -0.4488,-0.7041,0.4014,
  -0.3831,-0.7582,0.3836,
  -0.3121,-0.8047,0.3655,
  -0.2365,-0.8433,0.3472,
  -0.1573,-0.8737,0.3285,
  -0.0755,-0.8957,0.3095,
  0.0081,-0.9091,0.29,
  0.0925,-0.9137,0.2703,
  0.1769,-0.9098,0.2502,
  0.2605,-0.8975,0.23,
  0.3423,-0.8768,0.2095,
  0.4218,-0.8484,0.189,
  0.4979,-0.812,0.1685,
  0.5703,-0.7686,0.1481,
  0.638,-0.7181,0.1278,
  0.7008,-0.6615,0.1077,
  0.7577,-0.599,0.0879,
  0.8085,-0.5313,0.0683,
  0.8525,-0.459,0.0489,
  0.8897,-0.3829,0.0298,
  0.9193,-0.3035,0.0108,
  0.9416,-0.2217,-0.008,
  0.9557,-0.1381,-0.0268,
  0.9622,-0.0535,-0.0455,
  0.9604,0.0313,-0.0644,
  0.9508,0.1155,-0.0833,
  0.9331,0.1983,-0.1024,
  0.9078,0.2792,-0.1217,
  0.8749,0.3571,-0.1412,
  0.8348,0.4316,-0.1608,
  0.7876,0.5018,-0.1807,
  0.7341,0.5672,-0.2006,
  0.6743,0.627,-0.2206,
  0.6092,0.6809,-0.2406,
  0.539,0.7279,-0.2606,
  0.4646,0.7681,-0.2804,
  0.3864,0.8005,-0.3,
  0.3054,0.825,-0.3194,
  0.2223,0.8414,-0.3384,
  0.1378,0.849,-0.3571,
  0.0529,0.8479,-0.3755,
  -0.0315,0.8382,-0.3934,
  -0.1145,0.8196,-0.4109,
  -0.1951,0.7922,-0.4279,
  -0.2724,0.7562,-0.4445,
  -0.3454,0.712,-0.4605,
  -0.4131,0.6599,-0.4761,
  -0.4746,0.6004,-0.491,
  -0.5289,0.5342,-0.5054,
  -0.5751,0.462,-0.5192,
  -0.6124,0.3847,-0.5323,
  -0.6402,0.3034,-0.5447,
  -0.6575,0.2191,-0.5564,
  -0.6641,0.1332,-0.5673,
  -0.6593,0.0471,-0.5774,
  -0.643,-0.0377,-0.5866,
  -0.6153,-0.1195,-0.5951,
  -0.5761,-0.1966,-0.6027,
  -0.5261,-0.2672,-0.6093,
  -0.466,-0.3295,-0.6151,
  -0.3968,-0.3817,-0.6198,
  -0.32,-0.422,-0.6235,
  -0.2375,-0.4489,-0.6261,
  -0.1516,-0.4608,-0.6273,
  -0.0649,-0.4569,-0.6272,
  0.0194,-0.4366,-0.6255,
  0.0979,-0.3998,-0.6222,
  0.1668,-0.3475,-0.617,
  0.2225,-0.2814,-0.6097,
  0.2612,-0.2045,-0.6,
  0.2799,-0.1208,-0.5876,
  0.2765,-0.0356,-0.5722,
  0.2503,0.0447,-0.5532,
  0.2028,0.1134,-0.5301,
  0.1381,0.1637,-0.5025,
  0.0627,0.1907,-0.4698,
  -0.015,0.1918,-0.4317,
  -0.0859,0.168,-0.388,
  -0.1419,0.124,-0.3389,
  -0.1782,0.067,-0.2847,
  -0.1928,0.0047,-0.2262,
  -0.1869,-0.0556,-0.1642,
  -0.1637,-0.1085,-0.0995,
  -0.1271,-0.1504,-0.033,
  -0.0809,-0.1789,0.0347,
  -0.0291,-0.193,0.1028,
  0.0251,-0.192,0.1706,
  0.078,-0.1756,0.2374,
  0.1261,-0.1438,0.3022,
  0.1654,-0.0975,0.3641,
  0.1915,-0.0383,0.4218,
  0.2002,0.0303,0.474,
  0.1878,0.103,0.5196,
  0.1534,0.1728,0.5575,
  0.0984,0.2324,0.5878,
  0.0272,0.2761,0.611,
  -0.0543,0.3001,0.628,
  -0.1401,0.3033,0.6397,
  -0.2247,0.2862,0.6471,
  -0.3038,0.2508,0.6507,
  -0.3737,0.1995,0.6511,
  -0.4321,0.1354,0.6487,
  -0.4773,0.0615,0.644,
  -0.5084,-0.0193,0.6373,
  -0.5251,-0.104,0.629,
  -0.5277,-0.1902,0.6195,
  -0.5166,-0.2757,0.6091,
  -0.4926,-0.3584,0.598,
  -0.4568,-0.4366,0.5863,
  -0.4103,-0.5088,0.5741,
  -0.3544,-0.574,0.5614,
  -0.2902,-0.631,0.5481,
  -0.2193,-0.6792,0.5343,
  -0.143,-0.7179,0.5199,
  -0.0626,-0.747,0.5048,
  0.0207,-0.7661,0.489,
  0.1055,-0.7752,0.4727,
  0.1906,-0.7745,0.4558,
  0.2751,-0.7641,0.4385,
  0.3578,-0.7444,0.4209,
  0.4378,-0.7158,0.403,
  0.5143,-0.6787,0.3851,
  0.5864,-0.6337,0.3671,
  0.6533,-0.5814,0.3492,
  0.7146,-0.5224,0.3314,
  0.7696,-0.4576,0.3137,
  0.8176,-0.3874,0.2962,
  0.8586,-0.3128,0.2788,
  0.892,-0.2346,0.2614,
  0.9176,-0.1534,0.2439,
  0.9353,-0.0703,0.2263,
  0.9448,0.0142,0.2084,
  0.9464,0.0991,0.1902,
  0.9397,0.1837,0.1715,
  0.9254,0.2672,0.1524,
  0.9031,0.3487,0.1326,
  0.8735,0.4278,0.1123,
  0.8367,0.5036,0.0913,
  0.793,0.5756,0.0698,
  0.7432,0.6432,0.0477,
  0.6871,0.7056,0.0252,
  0.6257,0.7626,0.0022,
  0.5595,0.8137,-0.021,
  0.4887,0.8583,-0.0445,
  0.4143,0.8962,-0.0681,
  0.3367,0.9272,-0.0918,
  0.2565,0.9507,-0.1155,
  0.1744,0.9668,-0.139,
  0.0912,0.9751,-0.1625,
  0.0075,0.9757,-0.1858,
  -0.0759,0.9686,-0.2088,
  -0.1583,0.9534,-0.2317,
  -0.239,0.9307,-0.2543,
  -0.3172,0.9003,-0.2766,
  -0.3923,0.8626,-0.2987,
  -0.4634,0.8178,-0.3205,
  -0.53,0.7663,-0.342,
  -0.5912,0.7085,-0.3632,
  -0.6466,0.6449,-0.3841,
  -0.6953,0.576,-0.4046,
  -0.7369,0.5025,-0.4246,
  -0.7709,0.425,-0.4442,
  -0.7967,0.3443,-0.4633,
  -0.8139,0.2612,-0.4819,
  -0.8223,0.1767,-0.4998,
  -0.8215,0.0916,-0.5172,
  -0.8114,0.007,-0.5339,
  -0.7919,-0.0761,-0.5499,
  -0.763,-0.1565,-0.5653,
  -0.7249,-0.2332,-0.58,
  -0.678,-0.3049,-0.5941,
  -0.6227,-0.3704,-0.6075,
  -0.5595,-0.4286,-0.6202,
  -0.4894,-0.4783,-0.6323,
  -0.4132,-0.5185,-0.6436,
  -0.3322,-0.5479,-0.6542,
  -0.2479,-0.5658,-0.664,
  -0.1617,-0.5714,-0.673,
  -0.0756,-0.5641,-0.6811,
  0.0084,-0.5433,-0.6882,
  0.088,-0.5093,-0.6942,
  0.1608,-0.4624,-0.6993,
  0.2242,-0.4032,-0.7031,
  0.2756,-0.3334,-0.7058,
  0.3124,-0.2549,-0.7071,
  0.3324,-0.1705,-0.7069,
  0.3335,-0.0838,-0.7051,
  0.3146,0.0007,-0.7014,
  0.2756,0.0778,-0.6954,
  0.2177,0.1417,-0.6868,
  0.1445,0.1864,-0.6752,
  0.0618,0.2066,-0.66,
  -0.022,0.1986,-0.6405,
  -0.0963,0.1621,-0.6157,
  -0.1497,0.1018,-0.5846,
  -0.1732,0.0281,-0.5462,
  -0.1639,-0.0442,-0.5,
  -0.1274,-0.1007,-0.4457,
  -0.0754,-0.1326,-0.3844,
  -0.021,-0.1391,-0.3173,
  0.0262,-0.125,-0.246,
  0.0611,-0.097,-0.1717,
  0.0821,-0.0614,-0.0954,
  0.0895,-0.0231,-0.0179,
  0.0844,0.0144,0.0603,
  0.0681,0.0482,0.1385,
  0.0416,0.076,0.2164,
  0.0062,0.0951,0.2933,
  -0.0367,0.1028,0.3684,
  -0.0845,0.0953,0.4403,
  -0.1327,0.0687,0.5073,
  -0.1731,0.0203,0.5665,
  -0.1949,-0.0477,0.6152,
  -0.1888,-0.1255,0.6522,
  -0.1529,-0.1996,0.6782,
  -0.0919,-0.2585,0.6954,
  -0.0144,-0.2954,0.706,
  0.0711,-0.308,0.7116,
  0.157,-0.2969,0.7136,
  0.2374,-0.2646,0.713,
  0.308,-0.2144,0.7105,
  0.366,-0.15,0.7066,
  0.4095,-0.0752,0.7014,
  0.4378,0.0066,0.6951,
  0.4506,0.0921,0.6877,
  0.4482,0.1784,0.6791,
  0.4317,0.263,0.6693,
  0.4019,0.3438,0.6583,
  0.3602,0.419,0.6461,
  0.3081,0.4871,0.6329,
  0.2469,0.547,0.6187,
  0.1782,0.5979,0.6038,
  0.1034,0.6391,0.5881,
  0.024,0.6704,0.5719,
  -0.0586,0.6913,0.5551,
  -0.143,0.702,0.5378,
  -0.228,0.7026,0.52,
  -0.3123,0.6932,0.5015,
  -0.3949,0.6743,0.4825,
  -0.4747,0.6463,0.4627,
  -0.5507,0.6097,0.4421,
  -0.6221,0.5651,0.4207,
  -0.6882,0.5133,0.3985,
  -0.7483,0.4551,0.3754,
  -0.802,0.3911,0.3516,
  -0.8485,0.322,0.327,
  -0.8878,0.2488,0.3018,
  -0.9194,0.1721,0.276,
  -0.9432,0.0927,0.2499,
  -0.959,0.0115,0.2236,
  -0.9667,-0.0709,0.1971,
  -0.9663,-0.1536,0.1707,
  -0.9579,-0.2359,0.1444,
  -0.9416,-0.3172,0.1184,
  -0.9176,-0.3966,0.0927,
  -0.8858,-0.4733,0.0673,
  -0.8471,-0.547,0.0424,
  -0.8012,-0.6165,0.0179,
  -0.749,-0.6816,-0.0062,
  -0.6908,-0.7416,-0.0299,
  -0.627,-0.7957,-0.0532,
  -0.5585,-0.8438,-0.0761,
  -0.4854,-0.885,-0.0987,
  -0.4089,-0.9194,-0.1211,
  -0.3292,-0.9461,-0.1432,
  -0.2474,-0.9653,-0.1651,
  -0.1641,-0.9765,-0.1868,
  -0.08,-0.9798,-0.2083,
  0.0041,-0.9749,-0.2295,
  0.0874,-0.9619,-0.2505,
  0.169,-0.9408,-0.2713,
  0.2483,-0.9119,-0.2917,
  0.3244,-0.875,-0.3117,
  0.3966,-0.831,-0.3315,
  0.464,-0.7797,-0.3508,
  0.5259,-0.7218,-0.3696,
  0.5817,-0.6579,-0.3881,
  0.6307,-0.5885,-0.4061,
  0.6721,-0.5142,-0.4236,
  0.7054,-0.4359,-0.4407,
  0.7302,-0.3543,-0.4573,
  0.746,-0.2704,-0.4734,
  0.7524,-0.1853,-0.489,
  0.7491,-0.0998,-0.5042,
  0.7361,-0.0152,-0.5188,
  0.7133,0.0674,-0.5329,
  0.6806,0.1467,-0.5464,
  0.6385,0.2215,-0.5593,
  0.5874,0.2907,-0.5715,
  0.5278,0.3527,-0.5829,
  0.4605,0.4065,-0.5936,
  0.3865,0.4508,-0.6034,
  0.307,0.4845,-0.6124,
  0.2234,0.5065,-0.6205,
  0.1374,0.5159,-0.6276,
  0.0509,0.5122,-0.6338,
  -0.0339,0.4948,-0.6389,
  -0.1149,0.4638,-0.6429,
  -0.1894,0.4193,-0.6457,
  -0.2547,0.3623,-0.6472,
  -0.3084,0.2942,-0.6473,
  -0.3477,0.2169,-0.6457,
  -0.3705,0.1333,-0.6425,
  -0.3747,0.0468,-0.6373,
  -0.3592,-0.0382,-0.6299,
  -0.324,-0.1167,-0.6201,
  -0.2702,-0.1835,-0.6075,
  -0.201,-0.233,-0.5917,
  -0.1213,-0.2606,-0.5722,
  -0.0381,-0.2628,-0.5483,
  0.0399,-0.2391,-0.5194,
  0.1039,-0.1922,-0.4851,
  0.1462,-0.1284,-0.4447,
  0.1627,-0.0573,-0.3983,
  0.1534,0.011,-0.346,
  0.1227,0.068,-0.2885,
  0.0774,0.1083,-0.2266,
  0.0246,0.1298,-0.1612,
  -0.0293,0.133,-0.0933,
  -0.0795,0.1199,-0.0238,
  -0.1223,0.0931,0.0468,
  -0.1552,0.0552,0.1176,
  -0.1761,0.009,0.188,
  -0.1832,-0.0429,0.2572,
  -0.1746,-0.0971,0.3243,
  -0.149,-0.1499,0.3883,
  -0.1057,-0.1959,0.4476,
  -0.046,-0.2293,0.5007,
  0.0262,-0.2439,0.5463,
  0.1038,-0.2354,0.5836,
  0.1786,-0.2028,0.6127,
  0.2427,-0.1489,0.6345,
  0.2906,-0.0784,0.6502,
  0.3192,0.0026,0.661,
  0.3276,0.0887,0.6676,
  0.3163,0.1746,0.6707,
  0.287,0.2562,0.6708,
  0.2418,0.3302,0.6684,
  0.1834,0.3942,0.6639,
  0.1145,0.4465,0.6577,
  0.0376,0.486,0.65,
  -0.0446,0.5122,0.641,
  -0.1299,0.525,0.631,
  -0.216,0.5247,0.62,
  -0.301,0.5117,0.608,
  -0.3831,0.4869,0.5948,
  -0.4609,0.4511,0.5806,
  -0.533,0.4052,0.5651,
  -0.5984,0.3506,0.5486,
  -0.6562,0.2882,0.5309,
  -0.7057,0.2194,0.5121,
  -0.7466,0.1454,0.4924,
  -0.7782,0.0671,0.4719,
  -0.8005,-0.0141,0.4508,
  -0.8135,-0.0972,0.4293,
  -0.817,-0.1812,0.4074,
  -0.8112,-0.265,0.3854,
  -0.7963,-0.3477,0.3634,
  -0.7727,-0.4283,0.3414,
  -0.7408,-0.5061,0.3196,
  -0.7009,-0.5801,0.298,
  -0.6534,-0.6496,0.2766,
  -0.5991,-0.714,0.2553,
  -0.5386,-0.7726,0.2342,
  -0.4724,-0.8247,0.2132,
  -0.4015,-0.8702,0.1921,
  -0.3263,-0.9083,0.1711,
  -0.2478,-0.9389,0.15,
  -0.1668,-0.9616,0.1287,
  -0.0839,-0.9764,0.1074,
  0,-0.9831,0.0859,
  0.0841,-0.9817,0.0643,
  0.1677,-0.9723,0.0427,
  0.25,-0.9549,0.0211,
  0.3302,-0.9296,-0.0005,
  0.4077,-0.8969,-0.022,
  0.4817,-0.8567,-0.0434,
  0.5517,-0.8099,-0.0645,
  0.6169,-0.7563,-0.0854,
  0.6768,-0.6969,-0.106,
  0.7306,-0.6318,-0.1263,
  0.7782,-0.562,-0.1462,
  0.8187,-0.4877,-0.1658,
  0.8521,-0.4099,-0.1852,
  0.8776,-0.3291,-0.2042,
  0.8953,-0.2461,-0.2229,
  0.9047,-0.1618,-0.2415,
  0.9059,-0.0769,-0.2598,
  0.8987,0.0077,-0.278,
  0.883,0.0912,-0.296,
  0.859,0.1727,-0.3138,
  0.827,0.2515,-0.3314,
  0.7869,0.3265,-0.3489,
  0.7393,0.3971,-0.3662,
  0.6846,0.4624,-0.3832,
  0.6232,0.5215,-0.3999,
  0.5559,0.5738,-0.4162,
  0.4832,0.6186,-0.4322,
  0.4059,0.655,-0.4477,
  0.3249,0.6827,-0.4627,
  0.2413,0.7009,-0.4772,
  0.156,0.7094,-0.4911,
  0.0702,0.7079,-0.5044,
  -0.0149,0.6961,-0.5171,
  -0.098,0.6739,-0.5291,
  -0.1777,0.6415,-0.5405,
  -0.2528,0.5992,-0.5511,
  -0.3217,0.5474,-0.561,
  -0.3831,0.4866,-0.57,
  -0.4356,0.418,-0.5782,
  -0.4779,0.3425,-0.5855,
  -0.5087,0.2616,-0.5918,
  -0.527,0.1769,-0.5971,
  -0.5319,0.0904,-0.6013,
  -0.5227,0.0041,-0.6044,
  -0.4993,-0.0794,-0.6062,
  -0.4617,-0.1576,-0.6068,
  -0.4106,-0.2277,-0.606,
  -0.3473,-0.2869,-0.6037,
  -0.2736,-0.3325,-0.5997,
  -0.1922,-0.3618,-0.5939,
  -0.1065,-0.3728,-0.586,
  -0.0209,-0.3643,-0.5757,
  0.0599,-0.3358,-0.5628,
  0.1306,-0.2883,-0.5468,
  0.1859,-0.2245,-0.5274,
  0.2212,-0.1489,-0.5042,
  0.2333,-0.0677,-0.4767,
  0.2209,0.0117,-0.4445,
  0.1858,0.0816,-0.4073,
  0.1325,0.1351,-0.3651,
  0.0676,0.1677,-0.3179,
  -0.0011,0.1778,-0.2661,
  -0.0664,0.1665,-0.2102,
  -0.1225,0.1372,-0.1511,
  -0.1657,0.0941,-0.0894,
  -0.1936,0.0421,-0.0259,
  -0.2054,-0.0146,0.0387,
  -0.2011,-0.072,0.1037,
  -0.1811,-0.1264,0.1683,
  -0.1465,-0.1743,0.2318,
  -0.0987,-0.2124,0.2933,
  -0.0398,-0.2372,0.3519,
  0.0271,-0.2455,0.4064,
  0.0975,-0.2346,0.4558,
  0.1658,-0.2033,0.4991,
  0.2256,-0.1525,0.5358,
  0.2713,-0.0853,0.5659,
  0.299,-0.0068,0.5897,
  0.3066,0.0776,0.6078,
  0.2941,0.1624,0.6209,
  0.2627,0.2428,0.6295,
  0.2148,0.3149,0.6344,
  0.1532,0.3759,0.6361,
  0.081,0.4241,0.6353,
  0.0013,0.4581,0.6323,
  -0.0831,0.4777,0.6275,
  -0.1695,0.4827,0.6211,
  -0.2555,0.4736,0.613,
  -0.3388,0.4515,0.6035,
  -0.4178,0.4172,0.5924,
  -0.491,0.3722,0.58,
  -0.5571,0.3176,0.5661,
  -0.6152,0.255,0.551,
  -0.6647,0.1855,0.5346,
  -0.7049,0.1105,0.5172,
  -0.7355,0.0314,0.4989,
  -0.7564,-0.0507,0.4799,
  -0.7674,-0.1346,0.4603,
  -0.7686,-0.2191,0.4404,
  -0.7601,-0.3032,0.4202,
  -0.7422,-0.3857,0.4,
  -0.7153,-0.4658,0.3798,
  -0.6797,-0.5424,0.3597,
  -0.636,-0.6147,0.3397,
  -0.5848,-0.682,0.3198,
  -0.5267,-0.7435,0.2999,
  -0.4626,-0.7986,0.2801,
  -0.393,-0.8465,0.2602,
  -0.3188,-0.8871,0.2403
]);
